const toggleButton = document.querySelector(".tags-cloud-button");
const dropdownMenu = document.querySelector(".tags-cloud-list");
const iconOpen = toggleButton.querySelector(".icon-open");
const iconClose = toggleButton.querySelector(".icon-close");
const allTags = document.querySelectorAll(".tags-cloud-item .tag-link");

const initializeTabindex = () => {
  const container = document.querySelector(".tags-cloud-list");
  const items = document.querySelectorAll(".tags-cloud-item");

  if (items.length === 0) return;

  const itemWidth = items[0].offsetWidth;
  const containerWidth = container.offsetWidth;
  const itemsPerRow = Math.floor(containerWidth / itemWidth);

  allTags.forEach((tagLink, index) => {
    if (index < itemsPerRow) {
      tagLink.setAttribute("tabindex", "0");
    } else {
      tagLink.setAttribute("tabindex", "-1");
    }
  });
};

initializeTabindex();

const calculateHeight = () => {
  const container = document.querySelector(".tags-cloud-list");
  const items = document.querySelectorAll(".tags-cloud-item");

  const rowHeight = 50;
  const maxRows = 3;

  const itemsPerRow = Math.floor(container.offsetWidth / items[0].offsetWidth);
  const rowsCount = Math.ceil(items.length / itemsPerRow);

  let newHeight = 0;
  newHeight = Math.min(rowsCount, maxRows) * rowHeight;

  container.style.height = `${newHeight}px`;
};


toggleButton.addEventListener("click", (e) => {
  e.stopPropagation();

  dropdownMenu.classList.toggle("expanded");
  toggleButton.classList.toggle("active");

  if (dropdownMenu.classList.contains("expanded")) {
    iconOpen.style.display = "none";
    iconClose.style.display = "block";

    calculateHeight();

    allTags.forEach((tagLink) => {
      tagLink.setAttribute("tabindex", "0");
    });

    if (allTags.length > 0) {
      allTags[0].focus();
    }

  } else {
    iconOpen.style.display = "block";
    iconClose.style.display = "none";
    dropdownMenu.style.height = "50px";

    const container = document.querySelector(".tags-cloud-list");
    const items = document.querySelectorAll(".tags-cloud-item");
    const itemWidth = items[0].offsetWidth;
    const containerWidth = container.offsetWidth;
    const itemsPerRow = Math.floor(containerWidth / itemWidth);

    allTags.forEach((tagLink, index) => {
      if (index >= itemsPerRow) {
        tagLink.setAttribute("tabindex", "-1");
      }
    });
  }
});

dropdownMenu.addEventListener("click", (e) => {
  e.stopPropagation();
});

window.addEventListener("resize", () => {
  initializeTabindex();
  if (dropdownMenu.classList.contains("expanded")) {
    calculateHeight();
  }
});
